import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type PlayIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const PlayIcon = ({
  size = 14,
  color,
  colorScheme = 'dark',
  className,
}: PlayIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Play'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 14 14'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.91699 1.75L11.0837 7L2.91699 12.25V1.75Z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={2}
      />
    </svg>
  )
}
